/*
 * Klaviyo "Added to Cart" onsite tracking — restored custom event.
 *
 * Background: the legacy theme fired
 *   window._learnq.push(['track', 'Added to Cart', payload])
 * from every add-to-cart path (see the old app/utilities/klaviyo.js). That custom
 * event is the source of the Klaviyo "Added to Cart" metric (UFXMp8) that powers
 * the "Add to Cart" flow. The Klaviyo app embed does NOT emit this event, so the
 * metric went dark when the store replatformed on June 18, 2026.
 *
 * This restores it at the single chokepoint every add passes through: the global
 * window.fetch wrapper in layout/theme.liquid calls window.klaviyoTrackAddToCart()
 * with the parsed /cart/add.js response. Because PDP, quick-add, cart drawer,
 * bundles, the kit builder, CCLP heroes, quiz, etc. all POST to /cart/add.js, this
 * one hook covers them all — no per-component wiring to keep in sync.
 *
 * Automatic adds (free gifts, GWP, samples) are skipped so we match the legacy
 * behavior of tracking only user-initiated product adds.
 *
 * The event is marketing tracking, so it only fires while the visitor allows
 * marketing (window.consentGate, snippets/component-consent-gate.liquid). The
 * add to cart itself is never affected.
 */
(function () {
  // Line-item property keys that mark an automatic / non-product add. These are
  // set by the cart components that auto-inject items:
  //   _gwp / _gwp_item              -> component-cart-tiered-gwp.js
  //   _Evergreen Gwp                -> component-cart-evergreen-gwp.js
  //   _free_sample                  -> component-cart-samples.js
  //   _This is a free gift variant  -> component-cart-free-gift.js
  //   __wide_awake_gwp              -> component-cart-wide-awake-gwp.js
  var AUTO_ADD_PROPS = ['_gwp', '_gwp_item', '_Evergreen Gwp', '_free_sample', '_This is a free gift variant', '__wide_awake_gwp', '_wide_awake_gwp'];

  function isAutoAdd(item) {
    var props = item && item.properties;
    if (!props) return false;
    for (var i = 0; i < AUTO_ADD_PROPS.length; i++) {
      if (props[AUTO_ADD_PROPS[i]]) return true;
    }
    return false;
  }

  function toMajorUnits(cents) {
    return typeof cents === 'number' ? cents / 100 : cents;
  }

  // Mirrors the legacy payload shape (Title / ItemId / Categories / ImageUrl / Url
  // / Metadata{Brand, Price, CompareAtPrice}) so the metric's data stays consistent
  // with historical events.
  function buildPayload(item) {
    var image = (item.featured_image && item.featured_image.url) || item.image || '';
    var url = item.url
      ? (item.url.indexOf('http') === 0 ? item.url : window.location.origin + item.url)
      : '';
    var price = toMajorUnits(item.price);
    var compareAt = toMajorUnits(item.original_price);
    return {
      Title: item.product_title || item.title || '',
      ItemId: item.product_id || item.id,
      Categories: item.product_type ? [item.product_type] : [],
      ImageUrl: image,
      Url: url,
      Metadata: {
        Brand: item.vendor || '',
        Price: price,
        CompareAtPrice: compareAt && compareAt > price ? compareAt : price,
      },
    };
  }

  /**
   * Fire the Klaviyo "Added to Cart" event for a /cart/add.js response.
   * @param {object} addResponse parsed /cart/add.js body — a single line item, or
   *   { items: [...] } for a multi-item add (bundles / kit builder).
   */
  window.klaviyoTrackAddToCart = function (addResponse) {
    if (!addResponse) return;
    if (!window.consentGate || !window.consentGate.allowed('marketing')) return;
    var items = Array.isArray(addResponse.items) ? addResponse.items : [addResponse];

    // Fire once per add action, using the first user-added product. This matches
    // the legacy one-event-per-ATC behavior (bundles tracked their hero product).
    var product = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].id && !isAutoAdd(items[i])) {
        product = items[i];
        break;
      }
    }
    if (!product) return;

    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Added to Cart', buildPayload(product)]);
  };
})();
